import React from "react";
import { parseBlogContent } from "../services/blogContent";

const renderInlineTokens = (tokens, keyPrefix) => {
  return tokens.map((token, index) => {
    const key = `${keyPrefix}-${index}`;

    if (token.type === "bold") {
      return (
        <strong key={key} className="blog-detail__strong">
          {token.content}
        </strong>
      );
    }

    if (token.type === "inlineCode") {
      return (
        <code key={key} className="blog-detail__inline-code">
          {token.content}
        </code>
      );
    }

    if (token.type === "italics") {
      return (
        <em key={key} className="blog-detail__italics">
          {token.content}
        </em>
      );
    }

    return <React.Fragment key={key}>{token.content}</React.Fragment>;
  });
};

const BlogContentRenderer = ({ content, postId }) => {
  const segments = parseBlogContent(content);

  return (
    <div className="blog-detail__content">
      {segments.map((segment, index) => {
        if (segment.type === "code") {
          return (
            <div key={`${postId}-code-${index}`} className="blog-detail__code-block">
              <div className="blog-detail__code-header mono">{segment.language}</div>
              <pre className="blog-detail__code-pre">
                <code>{segment.content}</code>
              </pre>
            </div>
          );
        }

        if (segment.type === "list") {
          return (
            <ul key={`${postId}-list-${index}`} className="blog-detail__list">
              {segment.items.map((itemTokens, itemIndex) => (
                <li key={`${postId}-list-${index}-${itemIndex}`} className="blog-detail__list-item">
                  {renderInlineTokens(itemTokens, `${postId}-list-inline-${index}-${itemIndex}`)}
                </li>
              ))}
            </ul>
          );
        }

        return (
          <p key={`${postId}-paragraph-${index}`} className="blog-detail__paragraph">
            {renderInlineTokens(segment.tokens || [], `${postId}-paragraph-inline-${index}`)}
          </p>
        );
      })}
    </div>
  );
};

export default BlogContentRenderer;
